import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "ds-label",
    template: `
        <div [ngClass]="color">
            <ng-content></ng-content>
            <span *ngIf="icon" class="label-icon">
                <i [ngClass]="icon"></i>
            </span>
            <button *ngIf="canDelete"
                    type="button"
                    class="link item-delete-button"
                    [ngClass]="{'isHoverable': deleteHover}"
                    (click)="delete.emit()">
                <i class="far fa-times"></i>
            </button>
        </div>
    `,
    styles: [`
        @import "/src/styles/colors";

        div {
            display: inline-block;
            padding: 2px 8px;
            font-size: 12px;
            line-height: 16px;
            height: 20px;
            border-width: 1px;
            border-style: solid;
            border-radius: 2px;
            color: $gray-1;
            border-color: $gray-6;
            cursor: default;
            background-color: $gray-4;

            &:hover button.isHoverable {
                display: inline-flex;
            }
        }

        button {
            display: inline-flex;
            margin: 0 0 0 8px;
            padding: 0;
            color: $gray-9;

            &.isHoverable {
                display: none;
            }

            &:hover {
                text-decoration: none;
            }

            i {
                height: 12px;
                font-size: 12px;
            }
        }

        span.label-icon {
            margin-left: 0.25rem;
        }

        .none {
            color: $gray-7;
        }

        .insignificant {
            background-color: $grass-green-8;
            border-color: $grass-green-9;
        }

        .low {
            background-color: $grass-green-6;
            border-color: $grass-green-7;
        }

        .medium {
            background-color: $severity-medium-color;
            border-color: $autumn-orange-7;
        }

        .high {
            background-color: $severity-high-color;
            border-color: $cinnabar-red-7;
        }

        .extreme {
            background-color: $severity-extreme-color;
            border-color: $cinnabar-red-9;
        }

        .stable {
            background-color: $ds-blue-7;
            border-color: $ds-blue-8;
        }
    `],
})
export class DsLabelComponent {
    @Input() color: string = "none";
    @Input() icon: string = "";
    @Input() canDelete: boolean = false;
    @Input() deleteHover: boolean = false;

    @Output() delete = new EventEmitter<void>();

    constructor() {
    }
}
